import React, {Component} from "react";
import {connect} from "react-redux";
import {setShowRealizedBudget} from "../../../../actions/actions/eventStats";
import {budgetManagementMonths} from "../../../../constants/Months";

class BudgetMonths extends Component {

  handleClickOpen = () => {
    this.props.setShowRealizedBudget(true);
  }

  handleClickClose = () => {
    this.props.setShowRealizedBudget(false);
  }

  render() {
    return (
      <div className={'budget-months'}>
          <div className={'budget-months-button'}>
            {this.props.budgetManagement.showTargetBudget ?
              <button className={'month-button'} onClick={this.handleClickClose}>
                <img src="/img/icons/manage-BM/targetObjectifCross.svg"/>
              </button>
              :
              <button className={'month-button'} onClick={this.handleClickOpen}>
                <img src="/img/icons/manage-BM/targetObjectifPlus.svg"/>
              </button>
            }
          </div>
          {budgetManagementMonths.map(({legend}, index) => (
            <React.Fragment>
              <div
                className={"month-row"}
                style={
                  index % 2 === 0
                    ? {backgroundColor: "#FAFBFB"}
                    : {backgroundColor: "#F8F9FA"}
                }
                key={index}
              >
                <div className={"month-legend ml-3"}>{legend}</div>
              </div>
            </React.Fragment>
          ))}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
});

const mapDispatchToProps = {
  setShowRealizedBudget
};

export default connect(mapStateToProps, mapDispatchToProps)(BudgetMonths);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/BudgetMonths.js